import { SessionContext } from "context/SessionContext";
import { useContext } from "react";

const useSession = () => {
  return useContext(SessionContext);
};

export default useSession;
